export default __webpack_public_path__ + "static/media/profile-icon.b9a5d623.svg";